import React from 'react';
import { CardWrapper, CardTitle, DatesWrapper, Wrapper } from './AdditionalDatesStyled';
import { ReactComponent as ArrowRightIcon } from '../../images/chevron_right.svg';
import { ReactComponent as Calendar } from '../../images/calendar.svg';

interface AdditionalDatesCardProps {
  title: string;
  dates: string;
}

export const AdditionalDatesCard = ({ title, dates }: AdditionalDatesCardProps) => {
  return (
    <CardWrapper>
      <CardTitle>{title}</CardTitle>
      <DatesWrapper><Calendar /> {dates}</DatesWrapper>
    </CardWrapper>
  );
};

interface AdditionalDatesProps {
  dates: {
    name: string;
    dates: string;
  }[];
}

export const AdditionalDates = ({ dates }: AdditionalDatesProps) => {
  return (
    <Wrapper>
      {dates.map((date, index) => (
        <>
          <AdditionalDatesCard key={date.name} title={date.name} dates={date.dates} />
          {dates[index + 1] && <ArrowRightIcon />}
        </>
      ))}
    </Wrapper>
  );
};
